import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/api/ops`;
export const opsApi = axios.create({ baseURL: base, withCredentials: true });

export const opsLogin = (email, password) => opsApi.post("/auth/login", { email, password }).then((r) => r.data);
export const opsLogout = () => opsApi.post("/auth/logout").then((r) => r.data);
export const opsMe = () => opsApi.get("/auth/me").then((r) => r.data);

export const getClients = () => opsApi.get("/clients").then((r) => r.data);
export const createClient = (b) => opsApi.post("/clients", b).then((r) => r.data);
export const updateClient = (id, b) => opsApi.patch(`/clients/${id}`, b).then((r) => r.data);
export const deleteClient = (id) => opsApi.delete(`/clients/${id}`).then((r) => r.data);

export const getUsers = () => opsApi.get("/users").then((r) => r.data);
export const createUser = (b) => opsApi.post("/users", b).then((r) => r.data);
export const updateUser = (id, b) => opsApi.patch(`/users/${id}`, b).then((r) => r.data);
export const deleteUser = (id) => opsApi.delete(`/users/${id}`).then((r) => r.data);

export const getAccounts = () => opsApi.get("/social-accounts").then((r) => r.data);
export const createAccount = (b) => opsApi.post("/social-accounts", b).then((r) => r.data);
export const deleteAccount = (id) => opsApi.delete(`/social-accounts/${id}`).then((r) => r.data);

export const getTasks = () => opsApi.get("/tasks").then((r) => r.data);
export const createTask = (b) => opsApi.post("/tasks", b).then((r) => r.data);
export const updateTask = (id, b) => opsApi.patch(`/tasks/${id}`, b).then((r) => r.data);

export const getJobs = () => opsApi.get("/video-jobs").then((r) => r.data);
export const createJob = (form) => opsApi.post("/video-jobs", form, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const createCampaign = (b) => opsApi.post("/campaigns", b).then((r) => r.data);

export const getPosts = () => opsApi.get("/posts").then((r) => r.data);
export const createPost = (b) => opsApi.post("/posts", b).then((r) => r.data);
export const updatePost = (id, b) => opsApi.patch(`/posts/${id}`, b).then((r) => r.data);
export const approvePost = (id) => opsApi.post(`/posts/${id}/approve`).then((r) => r.data);

export const assistantChat = (session_id, message) => opsApi.post("/assistant/chat", { session_id, message }).then((r) => r.data);
export const getAssistantHistory = (session_id) => opsApi.get("/assistant/history", { params: { session_id } }).then((r) => r.data);
export const getDMs = () => opsApi.get("/dms").then((r) => r.data);
export const handleDM = (id, b) => opsApi.post(`/dms/${id}/handle`, b).then((r) => r.data);

export const fmtErr = (d) => {
  if (d == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || String(d);
};
